export default __webpack_public_path__ + "static/media/img-slider-craft-2024-3.353ad43e.png";